import form from './form';
import table from './table';

export default {
  layout: 'aoi',
  addBtn: 'add-btn',
  numAois: 'num-aois',
  grid: 'grid',
  table,
  form,
};
